export default "__VITE_ASSET__Ci$XGbia__"